module.exports = __webpack_public_path__ + "assets/static/media/app-rtl.6a758b7d.scss";